import { TypeDto } from "../../../models/agency-types";

const key = "modify-agency-types";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/43$/);
};

const modify = (resp) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const types = resp.data.Data.Agency.Types as TypeDto[];

	const DealerType = types.find(t => t.Code === "DEALER");
	const DealerLicenseType = types.find(t => t.Code === "DEALER_LICENSE");

	DealerType.Relationships.Items[0].Target = { Code: "DEALER_LICENSE" };
	DealerType.Relationships.Items[0].Kind = { Code: "HEIRARCHY_FORWARD" };

	DealerLicenseType.Relationships.Items[0].Target = { Code: "DEALER" };
	DealerLicenseType.Relationships.Items[0].Kind = { Code: "HEIRARCHY_REVERSE" };

	// eslint-disable-next-line no-console
	console.log("modified agency types", resp.data.Data);
	return resp;
};

export const modifyAgencyTypes = [key, applicable, modify];